import SetupHikIpPortSmsModal from './setup-hik-ip-port-sms-modal.vue'
export default SetupHikIpPortSmsModal
